<template>
  <v-row class="justify-center">
    <v-card max-width="800">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">
            {{$t('components.membersmanagementtable.reset_password')}}
          </h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          :disabled="loading"
          v-show="validToken"
        >
          <v-container fluid fill-height>
            <v-row>
              <v-col xs12 sm6 md4 lg3>
                <no-autocomplete-textfield
                  ref="password"
                  autocomplete="new-password"
                  v-model="password"
                  :type="'password'"
                  :rules="$rules.passwordRules"
                  :label="$t('views.firstlogin.password')"
                  validate-on-blur
                ></no-autocomplete-textfield>
              </v-col>
              <v-col xs12 sm6 md4 lg3>
                <no-autocomplete-textfield
                  ref="confirmPassword"
                  autocomplete="new-password"
                  v-model="confirmPassword"
                  :type="'password'"
                  :rules="confirmPasswordRules"
                  :label="$t('views.firstlogin.password_confirmation')"
                  validate-on-blur
                ></no-autocomplete-textfield>
              </v-col>
            </v-row>
            <v-flex xs12 sm6 md4 lg3>
              <vue-recaptcha
                v-on:expired="recaptchaValid=false"
                v-on:verify="recaptchaValid=true"
                :sitekey="settings.SiteKey"
              ></vue-recaptcha>
            </v-flex>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="$router.push('/')">{{$t('globals.cancel')}}</v-btn>
        <v-btn
          :disabled="!valid || !recaptchaValid"
          :loading="loading"
          color="primary"
          v-on:click="handleSubmit()"
          >{{$t('components.membersmanagementtable.reset_password')}}</v-btn
        >
      </v-card-actions>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn
          dark
          text
          @click="snackbar = false"
          >{{$t('globals.close')}}</v-btn
        >
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </v-card>
  </v-row>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { mapActions, mapGetters } from "vuex";
import jwt from "jsonwebtoken";
import ErrorHandler from "../components/ErrorHandler";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";

export default {
  name: "reset-password",
  data() {
    return {
      validToken: false,
      error: null,
      token: "",
      brokerId: "",
      id: null,
      loading: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      recaptchaValid: false,
      resetPasswordMessage: "",
      valid: true,
      confirmPasswordRules: [
        v => (v && v === this.password) || this.$t("validation.passwords_do_not_match")
      ],
      password: null,
      confirmPassword: null
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", ["settings"])
  },
  watch: {
    confirmPassword: {
      handler() {
        if (this.confirmPassword) {
          this.$refs.password.error = false;
          this.validate();
        }
      }
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    this.brokerId = this.$route.query.brokerId;
    this.id = this.$route.query.id;
    if (this.token) {
      this.validToken = true;
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("applicationUsers", ["resetPasswordWithToken"]),
    async handleSubmit() {
      this.loading = true;
      try {
        await this.resetPasswordWithToken({broker:this.brokerId, payload:{ Id: this.id, Password: this.password, Token: this.token }});
        this.color = "success";
        this.message = this.$t("components.membersmanagementtable.reset_password.success");
        this.snackbar = true;
        this.$router.push("/")
      } catch (error) {
        this.error = error;
      }
      this.loading = false;
    },
    validate() {
      if (this.$refs.form.validate()) {
        return true;
      }
      return false;
    }
  },
  components: { VueRecaptcha, ErrorHandler, NoAutocompleteTextfield }
};
</script>
